import { ThumbDownIcon, XCircleIcon } from '@heroicons/react/solid';
import React from 'react';

const FileUploaderEntries = (props) => {
  if (props.isUploading) {
    return (
      <>
        <label
          htmlFor="file"
          className="leading-7 text-sm text-gray-600 text-left"
        >
          Upload Image
        </label>
        <div className="flex items-center justify-center">
          <button
            type="button"
            className="w-full inline-flex justify-center items-center px-4 py-[0.55rem] text-sm font-semibold leading-6 text-white transition duration-150 ease-in-out bg-gray-500 rounded shadow cursor-not-allowed hover:bg-gray-400"
            disabled=""
          >
            <svg
              className="w-5 h-5 mr-3 -ml-1 text-white animate-spin"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            Shrinking...
          </button>
        </div>
      </>
    );
  }

  if (props.isServiceUp && !props.depletedService) {
    return (
      <>
        <label
          htmlFor="file"
          className="leading-7 text-sm text-gray-600 text-left"
        >
          Upload Image
        </label>

        <label className="w-full flex flex-row gap-2 justify-center items-center py-1 bg-gray-100 bg-opacity-50 rounded border border-gray-300 uppercase cursor-pointer hover:bg-accent-500 hover:text-white">
          <svg
            className="w-8 h-8"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
          </svg>
          <span className="text-base leading-normal">Select an Image</span>
          <input
            type="file"
            className="hidden"
            id="file"
            name="file"
            onChange={props.handleFileInput}
          />
        </label>
      </>
    );
  }

  return (
    <>
      <p className="leading-7 text-sm text-gray-600 text-right">
        {!props.depletedService
          ? 'Service is down! Click to recheck.'
          : 'Depleted compression service for this month.'}
      </p>
      <button
        type="button"
        disabled={props.depletedService}
        onClick={props.getService}
        className="text-red-500 bg-gray-200 py-3 px-8 focus:outline-none hover:bg-gray-300 hover:text-red-700 disabled:bg-gray-700 disabled:text-red-500 rounded text-lg float-right"
      >
        {!props.depletedService ? (
          <ThumbDownIcon className="w-5 h-5" />
        ) : (
          <XCircleIcon className="w-5 h-5" />
        )}
      </button>
    </>
  );
};

export default FileUploaderEntries;
